export const formatDate = (timestamp: Date | number, options?: {
    withHours?: boolean
    withSeconds?: boolean
}) => {
    if (!(timestamp instanceof Date)) {
        timestamp = new Date(timestamp)
    }
    return timestamp.toLocaleString('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: options?.withHours ? '2-digit' : undefined,
        minute: '2-digit',
        second: options?.withSeconds ? '2-digit' : undefined,
        hour12: false
    }).replace(',', '')
}
